import { render, staticRenderFns } from "./WeeklyScorecardReportForm.vue?vue&type=template&id=4f347dfb&scoped=true&"
import script from "./WeeklyScorecardReportForm.vue?vue&type=script&lang=js&"
export * from "./WeeklyScorecardReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f347dfb",
  null
  
)

export default component.exports